import { createStore } from '@stencil/store';
import { DistributionModalState } from '../types';

export const initialDistributionModal: DistributionModalState = JSON.parse(
  JSON.stringify({
    status: 'IDLE',
    adults: 1,
    minors: 0,
    ageMinors: [],
    productId: null,
    messageId: null,
    extraData: null,
  }),
);

const setDistributionModal = (distributionModal: Partial<DistributionModalState>) => {
  Object.keys(distributionModal).forEach(key => {
    set(key as keyof DistributionModalState, distributionModal[key as keyof DistributionModalState]);
  });
};

export const resetDistributionModal = () => {
  setDistributionModal(initialDistributionModal);
};

export const updateDistributionModal = (state: Partial<DistributionModalState>) => {
  setDistributionModal(state);
};

const { state, onChange, on, set, reset } = createStore<DistributionModalState>(initialDistributionModal);

window.document.addEventListener('reset-chat-stores', () => {
  reset();
});

export default state;
